module.exports = __webpack_public_path__ + "img/smg51_samurai01_shop.408936c6.png";